// @flow strict
// schema.org structure for address can be found here:
// https://schema.org/address

import * as React from 'react';

export type AddressType = {|
  line1: string,
  line2?: string,
  city: string,
  state: string,
  postcode: string,
  country: string,
|};

export default ({ address, className }: { address: AddressType, className?: string }) => (
  <div
    className={className}
    itemProp="address"
    itemScope
    itemType="http://schema.org/PostalAddress"
  >
    <span itemProp="streetAddress">
      {address.line1}
      {address.line2 && [<br key="br" />, address.line2]}
    </span>
    <br />
    <span itemProp="addressLocality">{address.city}</span>,{' '}
    <span itemProp="addressRegion">{address.state}</span>{' '}
    <span itemProp="postalCode">{address.postcode}</span>
    <br />
    <span itemProp="addressCountry">{address.country}</span>
  </div>
);
